import { inject } from 'vue';
import type { Ui2Config } from '@mop/ui2/types';

export default function useUi2Config() {
  return (inject<Ui2Config>('ui2Config') ?? {}) as Ui2Config;
}
